import i18n from "i18next";
import { faBriefcase } from "@fortawesome/pro-regular-svg-icons";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import type { AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { SingleSalesLeadView } from "src/components/views/erp/sales/crm/salesLeads/SingleSalesLeadView.tsx";
import { resolveValueOrProvider, ValueOrProvider } from "src/utils/valueOrProvider.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenSalesLeadButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	salesLeadId: ValueOrProvider<number | Promise<number>> | null | undefined;
}

export const OpenSalesLeadButton = ({
	salesLeadId: salesLeadIdProp,
	variant = "menu",
	...props
}: OpenSalesLeadButtonProps) => {
	const { openDialog } = useGenericDialog();

	return (
		<AsyncButton
			label={i18n.t("open_sales_lead")}
			icon={faBriefcase}
			variant={variant}
			disabled={salesLeadIdProp == null}
			onClick={async () => {
				if (salesLeadIdProp == null) return;
				const salesLeadId = await resolveValueOrProvider(salesLeadIdProp);
				openDialog({
					title: `${i18n.t("sales_lead")} ${salesLeadId}`,
					size: "fullscreen",
					agentContext: {
						key: defineAgentUiContextKey("erp.sales.salesLead.dialog"),
						data: { salesLeadId },
						pathSegments: [`${i18n.t("sales_lead")} ${salesLeadId}`],
					},
					content: <SingleSalesLeadView salesLeadId={salesLeadId} />,
				});
			}}
			{...props}
		/>
	);
};
